// type: functions
// descriptions: Fonctions utilitaires pour la gestion des événements DOM

/**
 * Délègue un événement à un sélecteur spécifique à partir d'une cible.
 * @param  target Élément sur lequel écouter l'événement
 * @param  event Nom de l'événement (ex: 'click')
 * @param  selector Sélecteur CSS pour filtrer la cible
 * @param  callback Fonction appelée lors de l'événement
 */
export function delegate<T extends HTMLElement>(
  target: T,
  event: string,
  selector: string,
  callback: (e: CustomEvent) => void,
): void {
  target.addEventListener(event, (e: Event) => {
    if (!(e.target instanceof HTMLElement)) return;

    // On cherche l'élément correspondant au sélecteur le plus proche
    const element = e.target.closest(selector);

    // On vérifie que l'élément trouvé est bien à l'intérieur de notre "target"
    if (element && target.contains(element)) {
      callback(
        new CustomEvent(event, {
          detail: { innerEvent: e, target: element },
        }),
      );
    }
  });
}
